import { storage } from "./firebase";
import { ref, uploadBytes, getDownloadURL } from "firebase/storage";

/**
 * Faz upload de um arquivo para o Firebase Storage e retorna a URL de download.
 * @param file Arquivo a ser enviado
 * @param path Caminho (pasta/nome) dentro do Storage
 * @returns URL de download do arquivo salvo
 */
export const uploadFile = (file: File, path: string): Promise<string> => {
  const storageRef = ref(storage, path);
  return uploadBytes(storageRef, file)
    .then(() => getDownloadURL(storageRef))
    .catch((error) => {
      return Promise.reject(error);
    });
};
